import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _isUndefined from 'lodash/isUndefined';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import I18n from 'i18n-js';
import classnames from 'classnames/bind';
import { withRouter } from 'react-router-dom';
import { Row, Icon } from 'grab-ui';
import {
  fetchCityOptions,
  toggleLocationDrawerAction,
} from 'actions/app-actions';
import { firstDeliverySelector } from 'selectors/new-booking-selectors';
import { NewBookingDeliveryPropType } from 'common/prop-types';
import {
  userInfoSelector,
  listCitiesSelector,
  enableAnytimeBookingUIBookingSelector,
  enableBookingPageRevampSelector,
} from 'selectors/app-selector';
import { bulkUploadProcessingSelector } from 'selectors/booking-selectors';
import {
  updateOrderAction,
  updateBulkOrderAction,
  clearOrdersActionV2,
  updateOrderShallowAction,
} from 'actions/booking-actions';
import { checkBookingFormReloadable, countTotalOrders } from 'helper/order';
import { getCompanyID } from 'helper/user';
import { trackClick, event, cat, custom } from 'common/utils/instrumentation';
import { ExceptMobile } from 'components/v2/responsive';
import CitySelect from 'components/v2/city-select/city-select';
import BookOrderWidget from 'components/v2/book-order-widget/book-order-widget';
import DivButton from 'components/v2/div-button/div-button';
import SpreadSheetModal from 'components/v2/spreadsheet/spreadsheet-modal';
import BackButtonModal from 'components/v2/back-button-modal/back-button-modal';
import { HomepageWidget } from 'components/v2/anytime-booking/homepage-widget';
import multipleBookingIcon from 'public/icons/multiple.svg';
import uploadIcon from 'public/icons/upload.svg';
import ContextualOnboarding from 'components/v2/contextual-onboarding';
import {
  scribeTrackEvent,
  getCommonFacet,
  SCRIBE_STATE_NAMES,
  SCRIBE_HOME_EVENTS,
  SCRIBE_EVENT_PARAMS,
  SCRIBE_COMMON_EVENTS,
  SCRIBE_BULK_UPLOAD_MODAL_EVENTS,
  SCRIBE_DELIVERY_DETAILS_EVENTS,
} from 'applications/scribe/instrumentations/track';
import {
  newBookingPageStateKey,
  newBookingPageStateModeValues,
  ROUTES_V2_PATHS,
} from 'constants/route-constants';
import { SHOW_NUDGE_BULK_UPLOAD_ORDERS } from 'constants/new-bulk-upload-const';
import {
  pushGALoginSuccessEvent,
  pushGAAddDeliveryDetail,
} from 'helper/ga-helper';
import { SuggestedPlacesHorizontal } from 'views/v2/saved-poi/suggested-places';
import ScribeDuck from 'ducks/scribe-duck';
import NewOrderSummarize from 'views/v2/new-order-summarize';
import OrderSummarize from './order-summarize';
import SingleOrderPage from './single-order-page';
import BulkOrderPage from './bulk-order-page';
import BulkUploadPage from './bulk-upload-page';
import { MODE } from './constants';
import css from './home.less';
import trackHomePageView from './home-tracking';
import { NudgeBulkUploadContent } from '../new-bulk-upload/upload-file/pop-up';

const cx = classnames.bind(css);

class Home extends Component {
  constructor(props) {
    super(props);
    const mode = _get(props, 'location.state.mode'); // from order-table-complex.jsx and order-notification.jsx
    this.state = {
      mode: _isUndefined(mode) ? MODE.HOME : mode,
      showSpreadsheetModal: false,
      bulkUploadReviewParams: {},
      backButtonModalVisible: false,
    };
    this.onConfirmUpdateLocation = () => {};
  }

  componentDidMount() {
    const { location, userInfo, order } = this.props;
    trackHomePageView(this.state.mode, userInfo, order);
    this.trackPageDefaultEvent();

    // reset location state from Previous Booking table Book Again action
    if (location && !_isEmpty(location.state)) {
      window.history.replaceState(null, '');
    }

    window.addEventListener('beforeunload', this.onbeforeunload);

    pushGALoginSuccessEvent(userInfo);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { bulkUploadProcessing, userInfo, order } = this.props;
    if (prevState.mode !== this.state.mode) {
      trackHomePageView(this.state.mode, userInfo, order);
      this.trackPageDefaultEvent();
    }

    const {
      success,
      reviewOrders,
      quoteParam,
      serviceTypeMap,
      paymentMethodMap,
      addressMap,
      bookingLimitValidation,
    } = bulkUploadProcessing;
    const prevSuccess = _get(prevProps, 'bulkUploadProcessing.success', false);
    if (!prevSuccess && success) {
      const { showSpreadsheetModal } = this.state;
      if (showSpreadsheetModal) {
        this.onToggleSpreadsheetModal();
      }
      this.showBulkUploadReviewPage({
        reviewOrders,
        quoteParam,
        serviceTypeMap,
        paymentMethodMap,
        addressMap,
        bookingLimitValidation,
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.onbeforeunload);
  }

  trackHomePageEvent = () => {
    const { userInfo, firstDelivery } = this.props;
    const source = _get(firstDelivery, 'detail.pickUp.source');
    const pickUpPoiID = _get(firstDelivery, 'detail.pickUp.poi.id');
    scribeTrackEvent({
      stateName: SCRIBE_STATE_NAMES.EXPRESS_HOMEPAGE_WEB,
      eventName: SCRIBE_HOME_EVENTS.DEFAULT,
      facets: {
        ...getCommonFacet(userInfo),
        [SCRIBE_EVENT_PARAMS.PICKUP_POI_ID]: pickUpPoiID || null,
        [SCRIBE_EVENT_PARAMS.PICKUP_POI_SRC]: source || null,
      },
    });
  };

  trackPageDefaultEvent = () => {
    const { mode } = this.state;
    const { userInfo } = this.props;
    if (mode === MODE.HOME) {
      setTimeout(this.trackHomePageEvent, 500);
    } else if (mode === MODE.SINGLE_BOOK || mode === MODE.MULTI_BOOK) {
      scribeTrackEvent({
        stateName: SCRIBE_STATE_NAMES.EXPRESS_DELIVERY_DETAILS_WEB,
        eventName: SCRIBE_DELIVERY_DETAILS_EVENTS.DEFAULT,
        facets: getCommonFacet(userInfo),
      });
    }
  };

  onbeforeunload = e => {
    e.preventDefault();
    const { userInfo, order, orders } = this.props;
    if (!checkBookingFormReloadable(userInfo, [].concat(order, orders))) {
      e.returnValue = '';
    }
  };

  onConfirmUpdateLocation = addresses => {
    const { toggleLocationDrawer } = this.props;
    toggleLocationDrawer(false);
  };

  onClickReviewOrder = () => {
    const { userInfo, order, countingOngoingOrders } = this.props;
    const companyID = getCompanyID(userInfo);

    trackClick(event.HOMEPAGE_CLICKS, cat.GE_HOMEPAGE, 'PROCEED', {
      [custom.COMPANY_ID]: companyID,
      PICKUP_POI: _get(order, 'senderLocation.id'),
      DROPOFF_POI: _get(order, 'recipientLocations[0].id'),
      SERVICE_TYPE: _get(order, 'SERVICE_TYPE.value'),
      FARE: _get(order, 'quote.forRender.amount'),
      CITY_ID: _get(userInfo, 'selectedCity.cityID'),
      ONGOING_BOOKINGS: countingOngoingOrders.total,
    });

    scribeTrackEvent({
      stateName: SCRIBE_STATE_NAMES.EXPRESS_HOMEPAGE_WEB,
      eventName: SCRIBE_HOME_EVENTS.CONFIRM,
      facets: {
        ...getCommonFacet(userInfo),
        [SCRIBE_EVENT_PARAMS.PICKUP_POI_ID]: _get(order, 'senderLocation.id'),
        [SCRIBE_EVENT_PARAMS.DROPOFF_POI_ID]: _get(
          order,
          'recipientLocations',
          [],
        ).map(loc => loc.id),
        // TODO: Are there better event param names?
        [SCRIBE_EVENT_PARAMS.SERVICE_TYPE]: _get(order, 'SERVICE_TYPE.value'),
        [SCRIBE_EVENT_PARAMS.TAXI_TYPE]: _get(order, 'SERVICE_TYPE.value'),
        [SCRIBE_EVENT_PARAMS.FARE]: _get(order, 'quote.forRender.amount'),
      },
    });

    this.setState({ mode: MODE.SINGLE_BOOK });

    pushGAAddDeliveryDetail(
      userInfo,
      MODE.SINGLE_BOOK,
      _get(order, 'quote.forRender.amount'),
      _get(order, 'SERVICE_TYPE.value'),
    );
  };

  onSelectBookingMode = mode => () => {
    const { userInfo, scribeExpressHomePageMultipleBookings } = this.props;
    const companyID = getCompanyID(userInfo);

    if (mode === MODE.MULTI_BOOK) {
      trackClick(event.HOMEPAGE_CLICKS, cat.GE_HOMEPAGE, 'MULTIPLE_BOOKINGS', {
        [custom.COMPANY_ID]: companyID,
      });

      scribeExpressHomePageMultipleBookings();
    }

    if (mode === MODE.SINGLE_BOOK) {
      scribeTrackEvent({
        stateName: SCRIBE_STATE_NAMES.EXPRESS_HOMEPAGE_WEB,
        eventName: SCRIBE_HOME_EVENTS.SINGLE_BOOKING,
        facets: {
          ...getCommonFacet(userInfo),
          [SCRIBE_EVENT_PARAMS.BOOKING_MODE]: MODE.SINGLE_BOOK,
        },
      });
    }

    if (this.state.mode !== mode) {
      this.setState({ mode });
    }
  };

  onClickBookAgain = callback => {
    this.setState({ mode: MODE.SINGLE_BOOK }, callback);
  };

  onToggleSpreadsheetModal = () => {
    const { showSpreadsheetModal } = this.state;
    const { userInfo } = this.props;
    const companyID = getCompanyID(userInfo);
    if (!showSpreadsheetModal) {
      trackClick(event.HOMEPAGE_CLICKS, cat.GE_HOMEPAGE, 'BULK_UPLOAD', {
        [custom.COMPANY_ID]: companyID,
      });

      scribeTrackEvent({
        stateName: SCRIBE_STATE_NAMES.EXPRESS_HOMEPAGE_WEB,
        eventName: SCRIBE_HOME_EVENTS.BULK_UPLOAD,
        facets: getCommonFacet(userInfo),
      });

      scribeTrackEvent({
        stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_WEB,
        eventName: SCRIBE_BULK_UPLOAD_MODAL_EVENTS.DEFAULT,
        facets: getCommonFacet(userInfo),
      });
    }
    this.setState({ showSpreadsheetModal: !showSpreadsheetModal });
  };

  onClickBackFromBookingFlow = () => {
    const { userInfo, order, orders } = this.props;
    const companyID = getCompanyID(userInfo);
    trackClick(event.DELIVERY_DETAILS_CLICKS, cat.GE_DELIVERY_DETAILS, 'BACK', {
      [custom.COMPANY_ID]: companyID,
    });
    scribeTrackEvent({
      stateName: SCRIBE_STATE_NAMES.EXPRESS_DELIVERY_DETAILS_WEB,
      eventName: SCRIBE_COMMON_EVENTS.BACK,
      facets: getCommonFacet(userInfo),
    });

    if (!checkBookingFormReloadable(userInfo, [].concat(order, orders))) {
      this.setState({
        backButtonModalVisible: true,
      });
    } else {
      this.setState({
        mode: MODE.HOME,
      });
    }
  };

  onClickBackFromBulkUpload = () => {
    const { userInfo } = this.props;
    trackClick(event.BULK_UPLOAD_REVIEW_PV, cat.GE_BULK_UPLOAD_REVIEW, 'BACK', {
      [custom.COMPANY_ID]: getCompanyID(userInfo),
    });
    scribeTrackEvent({
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_REVIEW_WEB,
      eventName: SCRIBE_COMMON_EVENTS.BACK,
      facets: getCommonFacet(userInfo),
    });

    this.setState({
      backButtonModalVisible: true,
    });
  };

  onBackCancel = () => {
    this.setState({ backButtonModalVisible: false });
  };

  onBackConfirm = () => {
    const { clearOrders } = this.props;
    clearOrders();
    this.setState({
      backButtonModalVisible: false,
      mode: MODE.HOME,
    });
  };

  onOrderCreateComplete = () => {
    this.setState({
      mode: MODE.HOME,
    });
  };

  getOrderWidgetServiceTypes = () => {
    const { userInfo, order, serviceTypeMap } = this.props;

    if (order.serviceTypes) return order.serviceTypes;
    const { cityID } = userInfo.selectedCity;
    return serviceTypeMap[cityID] || [];
  };

  showBulkUploadReviewPage = ({
    reviewOrders,
    quoteParam,
    serviceTypeMap,
    paymentMethodMap,
    addressMap,
    bookingLimitValidation,
  }) => {
    this.setState({
      mode: MODE.BULK_UPLOAD,
      bulkUploadReviewParams: {
        reviewOrders,
        quoteParam,
        serviceTypeMap,
        paymentMethodMap,
        addressMap,
        bookingLimitValidation,
      },
    });
  };

  renderBookingTabs = () => {
    const { mode } = this.state;
    return (
      <div className={css.bookingTabs}>
        <DivButton
          className={cx({
            'bookingTab-activated': mode === MODE.HOME,
          })}
          onClick={this.onSelectBookingMode(MODE.SINGLE_BOOK)}
        >
          {I18n.t('v2.homepage.bookOrderMode.singleBook')}
        </DivButton>
        <DivButton
          className={cx({
            'bookingTab-activated': mode === MODE.MULTI_BOOK,
          })}
          onClick={this.onSelectBookingMode(MODE.MULTI_BOOK)}
        >
          {I18n.t('v2.homepage.bookOrderMode.multipleBook')}
        </DivButton>
      </div>
    );
  };

  onClickNewMultipleBooking = () => {
    const { history, scribeExpressHomePageMultipleBookings } = this.props;
    history.push(ROUTES_V2_PATHS.newBooking, {
      [newBookingPageStateKey.INIT_MODE]: newBookingPageStateModeValues.MULTI,
    });

    scribeExpressHomePageMultipleBookings();
  };

  onRedirectToNewBulkUploadPage = () => {
    const { history } = this.props;
    history.push(ROUTES_V2_PATHS.bulkUpload);
  };

  render() {
    const {
      mode,
      showSpreadsheetModal,
      backButtonModalVisible,
      bulkUploadReviewParams,
    } = this.state;
    const {
      order,
      userInfo,
      cities,
      updateOrder,
      toggleLocationDrawer,
      locationDrawer,
      history,
      enableAnytimeBookingUIBooking,
      enableBookingPageRevamp,
      completedOrders,
      ongoingOrders,
    } = this.props;

    const companyID = getCompanyID(userInfo);

    return (
      <div className={css.home}>
        {mode === MODE.HOME && (
          <Fragment>
            <div className={css.actionRow}>
              <CitySelect cities={cities} companyID={companyID} />
              {enableAnytimeBookingUIBooking && (
                <div className={css.moreActions}>
                  <DivButton
                    className={css.actionBtn}
                    onClick={this.onClickNewMultipleBooking}
                  >
                    <ExceptMobile>
                      <img src={multipleBookingIcon} alt="" />
                    </ExceptMobile>
                    <h5>{I18n.t('v2.homepage.bookOrderMode.multipleBook')}</h5>
                  </DivButton>
                  <ExceptMobile>
                    <DivButton
                      id={'bulkUploadButton'}
                      className={css.actionBtn}
                      onClick={this.onRedirectToNewBulkUploadPage}
                    >
                      <img src={uploadIcon} alt="" />
                      <h5>{I18n.t('v2.homepage.bookOrderMode.bulkUpload')}</h5>
                    </DivButton>
                    {countTotalOrders(completedOrders) +
                      countTotalOrders(ongoingOrders) >
                      SHOW_NUDGE_BULK_UPLOAD_ORDERS && (
                      <ContextualOnboarding
                        elementID={'bulkUploadButton'}
                        onboardingID={'bulkUploadButton'}
                        onboardingVisual={
                          <NudgeBulkUploadContent
                            title={I18n.t(
                              'bulkUploadRevamp.step1.popover.nudge.title',
                            )}
                            desc={I18n.t(
                              'bulkUploadRevamp.step1.popover.nudge.description',
                            )}
                          />
                        }
                        onboardingVisualPlacement={'bottom'}
                        maxOnboardingTimes={1}
                        delay={500}
                        className={css.contextualOverwrite}
                      />
                    )}
                  </ExceptMobile>
                </div>
              )}
            </div>
            {!enableAnytimeBookingUIBooking && (
              <Row type="flex" justify="space-between">
                {this.renderBookingTabs()}
                <ExceptMobile>
                  <DivButton
                    className={css.bulkUploadBtn}
                    onClick={this.onToggleSpreadsheetModal}
                  >
                    <Icon type="upload" />
                    <h5>{I18n.t('v2.homepage.bookOrderMode.bulkUpload')}</h5>
                  </DivButton>
                </ExceptMobile>
              </Row>
            )}
            {!enableAnytimeBookingUIBooking && (
              <BookOrderWidget
                userInfo={userInfo}
                order={order}
                serviceTypes={this.getOrderWidgetServiceTypes()}
                updateOrder={updateOrder}
                toggleLocationDrawer={toggleLocationDrawer}
                onClickReviewOrder={this.onClickReviewOrder}
                locationDrawer={locationDrawer}
              />
            )}
            {enableAnytimeBookingUIBooking && <HomepageWidget />}
            <ExceptMobile>
              <SuggestedPlacesHorizontal />
            </ExceptMobile>
            {/* sanity to wait config being fetched to make sure old summarize component cycle not started along with revamped */}
            {enableBookingPageRevamp ===
            undefined ? null : enableBookingPageRevamp ? (
              <NewOrderSummarize />
            ) : (
              <OrderSummarize onClickBookAgain={this.onClickBookAgain} />
            )}
          </Fragment>
        )}
        {mode === MODE.SINGLE_BOOK && (
          <SingleOrderPage
            mode={mode}
            userInfo={userInfo}
            onClickBack={this.onClickBackFromBookingFlow}
            onOrderCreateComplete={this.onOrderCreateComplete}
          />
        )}
        {mode === MODE.MULTI_BOOK && (
          <BulkOrderPage
            mode={mode}
            userInfo={userInfo}
            onClickBack={this.onClickBackFromBookingFlow}
            onOrderCreateComplete={this.onOrderCreateComplete}
          />
        )}
        {mode === MODE.BULK_UPLOAD && (
          <BulkUploadPage
            userInfo={userInfo}
            onClickBack={this.onClickBackFromBulkUpload}
            onBackHome={this.onBackConfirm}
            initReviewParams={bulkUploadReviewParams}
            history={history}
          />
        )}
        <SpreadSheetModal
          userInfo={userInfo}
          visible={showSpreadsheetModal}
          onCancel={this.onToggleSpreadsheetModal}
          hideModal={this.onToggleSpreadsheetModal}
        />
        <BackButtonModal
          visible={backButtonModalVisible}
          onOk={this.onBackConfirm}
          onCancel={this.onBackCancel}
        />
      </div>
    );
  }
}

Home.propTypes = {
  order: PropTypes.shape({}),
  orders: PropTypes.arrayOf(PropTypes.shape({})),
  serviceTypeMap: PropTypes.shape({}),
  cities: PropTypes.arrayOf(PropTypes.shape({})),
  userInfo: PropTypes.shape({}).isRequired,
  updateOrder: PropTypes.func.isRequired,
  toggleLocationDrawer: PropTypes.func.isRequired,
  locationDrawer: PropTypes.shape({
    opening: PropTypes.bool.isRequired,
    locations: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  location: PropTypes.shape({}).isRequired,
  clearOrders: PropTypes.func.isRequired,
  history: PropTypes.shape({}).isRequired,
  bulkUploadProcessing: PropTypes.shape({}),
  countingOngoingOrders: PropTypes.shape({}),
  enableAnytimeBookingUIBooking: PropTypes.bool,
  enableBookingPageRevamp: PropTypes.bool,
  scribeExpressHomePageMultipleBookings: PropTypes.func.isRequired,
  completedOrders: PropTypes.arrayOf(PropTypes.shape({})),
  ongoingOrders: PropTypes.arrayOf(PropTypes.shape({})),
  firstDelivery: NewBookingDeliveryPropType,
};

Home.defaultProps = {
  order: {},
  orders: [],
  serviceTypeMap: {},
  cities: [],
  bulkUploadProcessing: {},
  countingOngoingOrders: {},
  firstDelivery: {},
  enableAnytimeBookingUIBooking: false,
  enableBookingPageRevamp: false,
  completedOrders: [],
  ongoingOrders: [],
};

const mapStateToProps = state => ({
  completedOrders: state.history.completedOrders,
  ongoingOrders: state.history.ongoingOrders,
  order: state.booking.order,
  orders: state.booking.orders,
  serviceTypeMap: state.booking.serviceTypeMap,
  userInfo: userInfoSelector(state),
  cities: listCitiesSelector(state),
  locationDrawer: state.app.locationDrawer,
  bulkUploadProcessing: bulkUploadProcessingSelector(state),
  countingOngoingOrders: state.history.countingOngoingOrders,
  enableAnytimeBookingUIBooking: enableAnytimeBookingUIBookingSelector(state),
  enableBookingPageRevamp: enableBookingPageRevampSelector(state),
  firstDelivery: firstDeliverySelector(state),
});

const mapDispatchToProps = {
  fetchCities: fetchCityOptions,
  toggleLocationDrawer: toggleLocationDrawerAction,
  updateOrder: updateOrderAction,
  updateOrderShallow: updateOrderShallowAction,
  updateBulkOrder: updateBulkOrderAction,
  clearOrders: clearOrdersActionV2,
  scribeExpressHomePageMultipleBookings:
    ScribeDuck.creators.scribeExpressHomePageMultipleBookings,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));
